export const prodHostname = 'app.custodynavigator.com';
export const testHostname = 'testapp.custodynavigator.com';
export const qaHostname = 'qaapp.testing.custodynavigator.com';

// The hostnames the lower environments are actually served on. ARCH-1104: only the three names above
// were recognised, and neither lower environment serves any of them, so both fell through to the
// ENV.DEV default. These are added rather than substituted — testapp.custodynavigator.com is a live
// name and is registered with Apple as an OAuth redirect target.
export const qaHostnames = [qaHostname, 'custody-navigator-qa.dev.ourfamilywizard.com'];
export const testHostnames = [testHostname, 'custody-navigator-test.preprod.ourfamilywizard.com'];
export const prodHostnames = [prodHostname];

export enum ENV {
  DEV = 'DEV',
  QA = 'QA',
  TEST = 'TEST',
  PROD = 'PROD',
}
